module.exports = __webpack_public_path__ + "static/newrow-d6130e80529ad1f0de78f9ae61a6cf88.png";